import { jsx as _jsx } from "react/jsx-runtime";
import { Modal, RepresentativeModalForm, useShowToast } from "@madmedical/ui";
import { ApiFormWrapper } from "@madmedical/form";
import { useTranslation } from "@madmedical/i18n";
import { useGetInvitesQuery, useUpdateInviteMutation } from "../api";
const EditInviteModal = ({ id, open, onClose }) => {
    const { invite } = useGetInvitesQuery(undefined, {
        selectFromResult: ({ data: invites }) => ({
            invite: invites === null || invites === void 0 ? void 0 : invites.find((invite) => invite.id === id),
        }),
    });
    const [update] = useUpdateInviteMutation();
    const showToast = useShowToast();
    const { t } = useTranslation();
    if (!id || !invite) {
        return null;
    }
    const handleSuccess = () => {
        showToast(t("commentModified"), { variant: "success" });
    };
    const { email, note } = invite;
    return (_jsx(Modal, Object.assign({ open: open, size: "sm", onClose: onClose }, { children: _jsx(ApiFormWrapper, Object.assign({ defaultValues: { id, email, note: note !== null && note !== void 0 ? note : "" }, mutation: update, onSuccess: handleSuccess }, { children: ({ submitForm, isSuccess }) => (_jsx(RepresentativeModalForm, { mode: "editInvite", onClose: onClose, onSubmitPress: submitForm, isSuccess: isSuccess })) })) })));
};
export default EditInviteModal;
